// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, setAgGridLicense } from '../../shared/services/common-functions';
import { getBeginWeeks, getEndWeeks } from '../../common/repositories';
import { getRegionalGroup, getRegionalGrpFamilies, getRegionalOrderAvailability } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import RegionalOrderAvailabilityTable from './components/regional-order-availability-table';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class RegionalOrderAvailability extends Component {

    state = {

        familyTypes: [],
        regions: [],
        beginWeeks: [],
        endWeeks: [],
        selectedFamilyType: '',
        selectedRegion: '',
        selectedBeginWeek: '',
        selectedEndWeek: '',
        results: null
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        setAgGridLicense();

    }

    componentDidMount = () => {

        this.props.increaseCounter();
        getRegionalGrpFamilies().then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getRegionalGroup().then( response => {

            this.setState( {
                regions: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getBeginWeeks().then( response => {

            this.setState( {
                beginWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleRegionChange ( val ) {

        this.setState( {
            selectedRegion: val
        }, () => {

            this.refresh();

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val
        }, () => {

            this.props.increaseCounter();
            getEndWeeks( val ).then( response => {

                this.setState( {
                    endWeeks: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedBeginWeek &&
             this.state.selectedEndWeek ) {

            this.props.increaseCounter();

            const { selectedFamilyType } = this.state;
            const { selectedRegion } = this.state;
            const { selectedBeginWeek } = this.state;
            const { selectedEndWeek } = this.state;

            getRegionalOrderAvailability( selectedFamilyType, selectedRegion,
                selectedBeginWeek, selectedEndWeek )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            familyTypes, regions, beginWeeks, endWeeks, selectedFamilyType,
            selectedRegion, selectedBeginWeek, selectedEndWeek, results
        } = this.state;

        function buildWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const beginWeekDates = beginWeeks ? beginWeeks.map( date => ( {
            label: buildWeekDate( date.beginWeek ), id: formatGivenDate( date.beginWeek, 'YYYY-MM-DD' )
        } ) ) : [];

        const endWeekDates = endWeeks ? endWeeks.map( date => ( {
            label: buildWeekDate( date.endWeek ), id: formatGivenDate( date.endWeek, 'YYYY-MM-DD' )
        } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Regional Order Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-regional-order-availability-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-regional-order-availability-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />

                                <OptionsDropDown
                                    className="atp-regional-order-availability-select"
                                    label="Region"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleRegionChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={regions}
                                    placeholder="Select Region"
                                    selectedValue={selectedRegion}
                                />

                                {selectedFamilyType && selectedRegion && (
                                    <OptionsDropDown
                                        className="atp-regional-order-availability-select"
                                        label="From"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['label']}
                                        optionKey="id"
                                        options={beginWeekDates}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                        isRequired={false}
                                    />

                                )}

                                {selectedBeginWeek && (
                                    <OptionsDropDown
                                        className="atp-regional-order-availability-select"
                                        label="To"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['label']}
                                        optionKey="id"
                                        options={endWeekDates}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                        isRequired={false}
                                    />

                                )}

                                {selectedFamilyType && selectedRegion && selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                            <div className="export-button">
                                {selectedFamilyType && selectedRegion &&
                                selectedBeginWeek && selectedEndWeek && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>
                        </div>

                        {selectedFamilyType && selectedRegion &&
                            selectedBeginWeek && selectedEndWeek && (
                            <RegionalOrderAvailabilityTable
                                results={results}
                                selectedBeginWeek={selectedBeginWeek}
                                selectedEndWeek={selectedEndWeek}
                                unitCode={this.props.unit.name}
                                ref={this.child}
                            />
                        ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

RegionalOrderAvailability.displayName = 'RegionalOrderAvailability';
RegionalOrderAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( RegionalOrderAvailability ) );
